import { ArrowUp, Clock, Facebook, Instagram, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { EMAIL, PHONE_DISPLAY, PHONE_HREF } from "../lib/site";

export const TikTokIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 1 0 15.7 15.7V8.75a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.18z" />
  </svg>
);

export const SOCIALS = [
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/profile.php?id=61594472977441", Icon: Facebook },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/trunorthrecovery", Icon: Instagram },
  { id: "x", label: "X (Twitter)", href: "https://x.com/TruNRecovey", Icon: Twitter },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@trunorthrecovery", Icon: TikTokIcon },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <img src="/images/logo-wide.png" alt="Tru North Towing and Recovery" className="h-12 mix-blend-screen" />
        <p className="mt-4 text-neutral-400 text-sm max-w-sm">
          24/7 mobile-only roadside assistance. Local technician. Upfront price. No surprise night/weekend fees.
        </p>
      </div>
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-4">Contact</p>
        <a href={PHONE_HREF} data-testid="footer-phone-link" className="flex items-center gap-2 text-sm text-neutral-300 hover:text-primary transition-colors duration-200">
          <Phone size={14} /> {PHONE_DISPLAY}
        </a>
        <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-2 text-sm text-neutral-300 hover:text-primary transition-colors duration-200 mt-3 break-all">
          <Mail size={14} className="shrink-0" /> {EMAIL}
        </a>
      </div>
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-4">Hours &amp; Area</p>
        <p className="flex items-center gap-2 text-sm text-neutral-300"><Clock size={14} /> 24/7 — 365 days</p>
        <p className="flex items-center gap-2 text-sm text-neutral-300 mt-3"><MapPin size={14} /> Minneapolis &amp; Twin Cities metro</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-wrap items-center justify-between gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">
        <span>© 2026 Tru North Towing and Recovery</span>
        <div data-testid="footer-social-links" className="flex items-center gap-2">
          <a href="/follow" data-testid="footer-follow-link" className="mr-2 hidden sm:inline hover:text-primary transition-colors duration-200">Follow</a>
          {SOCIALS.map(({ id, label, href, Icon }) => (
            <a
              key={id}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-social-${id}`}
              aria-label={label}
              title={label}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-neutral-400 hover:text-primary hover:border-primary/60 hover:-translate-y-0.5 transition-all duration-200"
            >
              <Icon size={15} />
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);
